import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { getApiBase } from '../services/api';
import { useAuth } from '../context/AuthContext';

const utentiApi = {
  getAll:  ()         => api.get('/utenti'),
  create:  data       => api.post('/utenti', data),
  update:  (id, data) => api.put(`/utenti/${id}`, data),
  delete:  id         => api.delete(`/utenti/${id}`),
};

const RUOLI = [
  { value: 'admin',      label: '🔑 Admin',      desc: 'Accesso completo' },
  { value: 'segreteria', label: '📋 Segreteria',  desc: 'Clienti, contratti, fatture' },
  { value: 'tecnico',    label: '🔧 Tecnico',     desc: 'Solo interventi e app' },
];

export default function ImpostazioniPage() {
  const [tab, setTab] = useState('utenti');
  const { isAdmin }   = useAuth();

  if (!isAdmin) return (
    <div className="page-content">
      <div className="card" style={{ textAlign:'center', padding:48 }}>
        <div style={{ fontSize:48 }}>🔒</div>
        <h3>Accesso riservato agli amministratori</h3>
      </div>
    </div>
  );

  return (
    <div className="page-content">
      <div style={{ display:'flex', gap:8, marginBottom:20 }}>
        {[['utenti','👥 Utenti'],['sistema','⚙️ Sistema'],['flotta','🚐 Flotta']].map(([k,l])=>(
          <button key={k}
            className={`btn ${tab===k?'btn-primary':'btn-secondary'}`}
            onClick={()=>setTab(k)}>{l}</button>
        ))}
      </div>
      {tab==='utenti' && <GestioneUtenti />}
      {tab==='sistema' && <Sistema />}
      {tab==='flotta'  && <ImpostazioniFlotta />}
    </div>
  );
}

function GestioneUtenti() {
  const [utenti, setUtenti]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShow]   = useState(false);
  const [editId, setEditId]   = useState(null);
  const [form, setForm]       = useState({ username:'', password:'', email:'', nome:'', ruolo:'segreteria' });
  const [error, setError]     = useState('');
  const [saving, setSaving]   = useState(false);

  const carica = async () => {
    setLoading(true);
    try { const r = await utentiApi.getAll(); setUtenti(r.data||[]); }
    catch(e){ console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(()=>{ carica(); },[]);

  const apriNuovo = () => {
    setForm({username:'',password:'',email:'',nome:'',ruolo:'segreteria'});
    setEditId(null); setError(''); setShow(true);
  };

  const apriModifica = (u) => {
    setForm({username:u.username,password:'',email:u.email||'',nome:u.nome||'',ruolo:u.ruolo});
    setEditId(u.id); setError(''); setShow(true);
  };

  const salva = async () => {
    setSaving(true); setError('');
    try {
      if (editId) {
        const payload = { nome:form.nome, email:form.email, ruolo:form.ruolo };
        if (form.password) payload.password = form.password;
        await utentiApi.update(editId, payload);
      } else {
        if (!form.username||!form.password) { setError('Username e password obbligatori.'); setSaving(false); return; }
        await utentiApi.create(form);
      }
      setShow(false); await carica();
    } catch(e){ setError(e.response?.data?.error||'Errore.'); }
    finally { setSaving(false); }
  };

  const elimina = async (u) => {
    if (!window.confirm(`Eliminare utente "${u.username}"?`)) return;
    try { await utentiApi.delete(u.id); await carica(); }
    catch(e){ alert(e.response?.data?.error||'Errore.'); }
  };

  const badgeRuolo = r => {
    const map = { admin:'badge-red', segreteria:'badge-blue', tecnico:'badge-green' };
    return <span className={`badge ${map[r]||'badge-gray'}`}>{r}</span>;
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <h3 style={{margin:0}}>👥 Gestione utenti</h3>
        <button className="btn btn-primary" onClick={apriNuovo}>➕ Nuovo utente</button>
      </div>

      {showForm && (
        <div className="card" style={{marginBottom:16,border:'2px solid #b30000'}}>
          <h4 style={{margin:'0 0 16px'}}>{editId?'✏️ Modifica utente':'➕ Nuovo utente'}</h4>
          {error && <div className="error-msg" style={{marginBottom:12}}>{error}</div>}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            {!editId && (
              <div className="form-group" style={{margin:0}}>
                <label className="form-label">Username *</label>
                <input className="form-control" value={form.username}
                  onChange={e=>setForm(f=>({...f,username:e.target.value}))} />
              </div>
            )}
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Nome completo</label>
              <input className="form-control" value={form.nome}
                onChange={e=>setForm(f=>({...f,nome:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Email</label>
              <input type="email" className="form-control" value={form.email}
                onChange={e=>setForm(f=>({...f,email:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">{editId?'Nuova password (lascia vuoto per non cambiare)':'Password *'}</label>
              <input type="password" className="form-control" value={form.password}
                onChange={e=>setForm(f=>({...f,password:e.target.value}))}
                placeholder={editId?'••••••••':''} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Ruolo</label>
              <select className="form-control" value={form.ruolo}
                onChange={e=>setForm(f=>({...f,ruolo:e.target.value}))}>
                {RUOLI.map(r=>(
                  <option key={r.value} value={r.value}>{r.label} — {r.desc}</option>
                ))}
              </select>
            </div>
          </div>
          <div style={{display:'flex',gap:8,marginTop:16}}>
            <button className="btn btn-primary" onClick={salva} disabled={saving}>
              {saving?'Salvataggio…':'💾 Salva'}
            </button>
            <button className="btn btn-secondary" onClick={()=>setShow(false)}>Annulla</button>
          </div>
        </div>
      )}

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card" style={{padding:0}}>
          <div className="table-wrap">
            <table className="q-table">
              <thead><tr>
                <th>Username</th><th>Nome</th><th>Email</th><th>Ruolo</th><th>Stato</th><th></th>
              </tr></thead>
              <tbody>
                {utenti.map(u=>(
                  <tr key={u.id}>
                    <td><strong>{u.username}</strong></td>
                    <td>{u.nome||'—'}</td>
                    <td style={{fontSize:12,color:'#6b7280'}}>{u.email||'—'}</td>
                    <td>{badgeRuolo(u.ruolo)}</td>
                    <td>
                      <span className={`badge ${u.attivo?'badge-green':'badge-gray'}`}>
                        {u.attivo?'Attivo':'Disattivo'}
                      </span>
                    </td>
                    <td style={{display:'flex',gap:6}}>
                      <button className="btn btn-secondary btn-sm" onClick={()=>apriModifica(u)}>✏️</button>
                      <button className="btn btn-danger btn-sm" onClick={()=>elimina(u)}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function Sistema() {
  const tenantSub = localStorage.getItem('quindi_tenant') || '—';
  const [emailForm, setEmailForm] = useState({
    smtpHost: '', smtpPort: '465', username: '', password: '', fromName: ''
  });
  const [loading, setLoading]   = useState(true);
  const [saving,  setSaving]    = useState(false);
  const [msg,     setMsg]       = useState('');

  useEffect(() => {
    api.get('/impostazioni/email').then(r => {
      if (r.data?.data) setEmailForm(f => ({...f, ...r.data.data}));
    }).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  const salvaEmail = async () => {
    setSaving(true); setMsg('');
    try {
      await api.post('/impostazioni/email', emailForm);
      setMsg('✅ Impostazioni email salvate!');
    } catch(e) { setMsg('Errore: ' + (e.response?.data?.error||e.message)); }
    finally { setSaving(false); }
  };

  const testEmail = async () => {
    setSaving(true); setMsg('');
    try {
      await api.post('/impostazioni/email/test', emailForm);
      setMsg('✅ Email di test inviata a ' + emailForm.username);
    } catch(e) { setMsg('Errore invio test: ' + (e.response?.data?.error||e.message)); }
    finally { setSaving(false); }
  };

  return (
    <div style={{display:'grid',gap:16,maxWidth:600}}>
      <div className="card">
        <h3 style={{margin:'0 0 16px'}}>⚙️ Informazioni sistema</h3>
        <table style={{width:'100%',fontSize:13}}>
          <tbody>
            <tr><td style={{color:'#9ca3af',padding:'6px 0',width:'40%'}}>Tenant</td>
                <td><strong>{tenantSub}</strong></td></tr>
            <tr><td style={{color:'#9ca3af',padding:'6px 0'}}>Versione</td>
                <td>Quindi SaaS v1.1</td></tr>
            <tr><td style={{color:'#9ca3af',padding:'6px 0'}}>FIC</td>
                <td><span className="badge badge-green">✅ Connesso</span></td></tr>
            <tr><td style={{color:'#9ca3af',padding:'6px 0'}}>Uptime</td>
                <td>
                  <Link to="/vacanza" style={{color:'#9ca3af',textDecoration:'none'}}
                    title="">stabile</Link>
                </td></tr>
          </tbody>
        </table>
      </div>

      <div className="card">
        <h3 style={{margin:'0 0 16px'}}>📧 Impostazioni email (SMTP)</h3>
        {loading ? <div className="loading"><div className="spinner"></div></div> : (
          <div style={{display:'grid',gap:10}}>
            <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:10}}>
              <div className="form-group" style={{margin:0}}>
                <label className="form-label">Server SMTP</label>
                <input className="form-control" value={emailForm.smtpHost||''}
                  onChange={e=>setEmailForm(f=>({...f,smtpHost:e.target.value}))}
                  placeholder="smtps.aruba.it" />
              </div>
              <div className="form-group" style={{margin:0}}>
                <label className="form-label">Porta</label>
                <select className="form-control" value={emailForm.smtpPort||'465'}
                  onChange={e=>setEmailForm(f=>({...f,smtpPort:e.target.value}))}>
                  <option value="465">465 (SSL)</option>
                  <option value="587">587 (TLS)</option>
                  <option value="25">25</option>
                </select>
              </div>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Email mittente (username SMTP)</label>
              <input type="email" className="form-control" value={emailForm.username||''}
                onChange={e=>setEmailForm(f=>({...f,username:e.target.value}))}
                placeholder="info@azienda.it" />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Password SMTP</label>
              <input type="password" className="form-control" value={emailForm.password||''}
                onChange={e=>setEmailForm(f=>({...f,password:e.target.value}))}
                placeholder="••••••••" />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Nome mittente</label>
              <input className="form-control" value={emailForm.fromName||''}
                onChange={e=>setEmailForm(f=>({...f,fromName:e.target.value}))}
                placeholder="SOS FIRE S.R.L.S." />
            </div>
            {msg && <div style={{fontSize:13,color:msg.includes('✅')?'#16a34a':'#dc2626'}}>{msg}</div>}
            <div style={{display:'flex',gap:8,marginTop:4}}>
              <button className="btn btn-primary" onClick={salvaEmail} disabled={saving}>
                {saving?'...':'💾 Salva'}
              </button>
              <button className="btn btn-secondary" onClick={testEmail} disabled={saving}>
                {saving?'...':'📧 Invia email di test'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── IMPOSTAZIONI FLOTTA ───────────────────────────────────────
function ImpostazioniFlotta() {
  const [dispositivi, setDispositivi] = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [showForm,    setShowForm]    = useState(false);
  const [form,        setForm]        = useState({ name:'', uniqueId:'', model:'', contact:'' });
  const [saving,      setSaving]      = useState(false);
  const [msg,         setMsg]         = useState('');

  const carica = async () => {
    setLoading(true);
    try {
      const r = await api.get('/flotta/dispositivi');
      setDispositivi(r.data || []);
    } catch(e) { setMsg('Errore caricamento: ' + e.message); }
    finally { setLoading(false); }
  };

  useEffect(() => { carica(); }, []);

  const aggiungi = async () => {
    if (!form.name.trim() || !form.uniqueId.trim()) {
      setMsg('Nome e ID dispositivo sono obbligatori.');
      return;
    }
    setSaving(true); setMsg('');
    try {
      await api.post('/flotta/dispositivi', form);
      setMsg('✅ Veicolo aggiunto!');
      setForm({ name:'', uniqueId:'', model:'', contact:'' });
      setShowForm(false);
      await carica();
    } catch(e) { setMsg('Errore: ' + (e.response?.data?.error || e.message)); }
    finally { setSaving(false); }
  };

  const elimina = async (id, nome) => {
    if (!window.confirm(`Eliminare "${nome}"?`)) return;
    try {
      await api.delete(`/flotta/dispositivi/${id}`);
      await carica();
    } catch(e) { setMsg('Errore: ' + e.message); }
  };

  return (
    <div style={{ display:'grid', gap:16, maxWidth:700 }}>
      <div className="card">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
          <h3 style={{ margin:0, fontSize:15 }}>🚐 Veicoli registrati</h3>
          <button className="btn btn-primary btn-sm" onClick={() => setShowForm(v=>!v)}>
            {showForm ? '✕ Annulla' : '➕ Aggiungi veicolo'}
          </button>
        </div>

        {showForm && (
          <div style={{ background:'#f9fafb', border:'1px solid #e5e7eb', borderRadius:8, padding:14, marginBottom:14 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
              <div className="form-group" style={{ margin:0 }}>
                <label className="form-label">Nome veicolo *</label>
                <input className="form-control" value={form.name}
                  onChange={e=>setForm(f=>({...f,name:e.target.value}))}
                  placeholder="es. Furgone 1 - Marco" />
              </div>
              <div className="form-group" style={{ margin:0 }}>
                <label className="form-label">ID dispositivo GPS *</label>
                <input className="form-control" value={form.uniqueId}
                  onChange={e=>setForm(f=>({...f,uniqueId:e.target.value}))}
                  placeholder="es. 863711234567890 (IMEI)" />
              </div>
              <div className="form-group" style={{ margin:0 }}>
                <label className="form-label">Modello veicolo</label>
                <input className="form-control" value={form.model}
                  onChange={e=>setForm(f=>({...f,model:e.target.value}))}
                  placeholder="es. Fiat Ducato" />
              </div>
              <div className="form-group" style={{ margin:0 }}>
                <label className="form-label">Autista / Referente</label>
                <input className="form-control" value={form.contact}
                  onChange={e=>setForm(f=>({...f,contact:e.target.value}))}
                  placeholder="es. Marco Verdi" />
              </div>
            </div>
            {msg && <div style={{ fontSize:12, color: msg.includes('✅')?'#16a34a':'#dc2626', marginTop:8 }}>{msg}</div>}
            <button className="btn btn-primary" style={{ marginTop:10 }} onClick={aggiungi} disabled={saving}>
              {saving ? '...' : '💾 Aggiungi'}
            </button>
          </div>
        )}

        {loading ? (
          <div className="loading"><div className="spinner"></div></div>
        ) : dispositivi.length === 0 ? (
          <div style={{ padding:16, textAlign:'center', color:'#9ca3af', fontSize:13 }}>
            Nessun veicolo configurato. Aggiungi il primo veicolo.
          </div>
        ) : (
          <table className="q-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>ID GPS (IMEI)</th>
                <th>Modello</th>
                <th>Autista</th>
                <th>Stato</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {dispositivi.map(d => (
                <tr key={d.id}>
                  <td><strong>{d.name}</strong></td>
                  <td style={{ fontFamily:'monospace', fontSize:12 }}>{d.uniqueId}</td>
                  <td>{d.model || '—'}</td>
                  <td>{d.contact || '—'}</td>
                  <td>
                    <span className={`badge ${d.status==='online'?'badge-green':'badge-gray'}`}>
                      {d.status==='online'?'● Online':'○ Offline'}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-danger btn-sm" onClick={()=>elimina(d.id, d.name)}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {msg && !showForm && <div style={{ fontSize:12, color:'#dc2626', marginTop:8 }}>{msg}</div>}
      </div>

      <div className="card">
        <h3 style={{ margin:'0 0 12px', fontSize:15 }}>📡 Configurazione tracker GPS</h3>
        <div style={{ fontSize:13, color:'#6b7280', lineHeight:1.8 }}>
          <p>Per collegare un tracker GPS (es. Teltonika FMB920) a Quindi:</p>
          <ol style={{ paddingLeft:20, margin:'8px 0' }}>
            <li>Configura il tracker per inviare dati al server Traccar</li>
            <li>Inserisci il numero <strong>IMEI</strong> del tracker come "ID dispositivo GPS" sopra</li>
            <li>Il veicolo apparirà automaticamente sulla mappa Flotta quando inizia a trasmettere</li>
          </ol>
          <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:6, padding:'10px 14px', marginTop:12 }}>
            <div style={{ fontWeight:600, fontSize:12, color:'#16a34a', marginBottom:4 }}>Parametri server Traccar</div>
            <div style={{ fontFamily:'monospace', fontSize:12, color:'#374151' }}>
              <div>Protocollo: <strong>Teltonika</strong></div>
              <div>Server IP: <strong>94.177.164.75</strong></div>
              <div>Porta: <strong>5027</strong></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
